import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { ReviewStatisticFragmentFragmentDoc } from '@packages/gql/generated/shopping/ReviewStatisticFragmentFragmentDoc';
import { Stack, Typography } from '@packages/shared';
import { useIntl } from 'react-intl';
import { reviewStatisticMessages } from './messages';
import { RatingPortionMUI } from '../RatingPortionMUI';

/* GraphQL */ `
  fragment ReviewStatisticFragment on ReviewStatistic {
    ...RatingPortionFragment
    rating
    count
  }
`;

type ReviewStatisticProps = {
  data: FragmentType<typeof ReviewStatisticFragmentFragmentDoc>;
};

export const ReviewStatistic = ({ data }: ReviewStatisticProps) => {
  const { formatMessage } = useIntl();
  const unmaskedData = getFragmentData(ReviewStatisticFragmentFragmentDoc, data);

  return (
    <Stack alignItems="center" gap={1} flexDirection="row">
      <Typography variant="body3" sx={{ width: 60 }}>
        {formatMessage(reviewStatisticMessages.label, { rating: unmaskedData.rating })}
      </Typography>
      <RatingPortionMUI data={unmaskedData} />
      <Typography
        variant="body3"
        sx={{ minWidth: 30, textAlign: 'right' }}
      >{`(${unmaskedData.count})`}</Typography>
    </Stack>
  );
};
